import { ACTIVITY_TYPE, AD_OBJECT_AD_CAMPAIGN, AD_OBJECT_AD_GROUP, AD_OBJECT_AD, ALL_OBJECT_PROPERTIES, AUTOMATED_EMAIL, AUTOMATION_PLATFORM_WORKFLOWS, BUSINESS_UNIT, CALL_DISPOSITION, CHATFLOW_BY_UNIQUE_ID, CHATFLOW, COMPANY_PROPERTY, COMPANY, CONTACT_LIST, CONTACT_PROPERTY, CONTACT_STATIC_LIST, CONTACT, CONVERSATION_INBOX, CTA_GUID, CUSTOM_OBJECT_TYPE, CUSTOM_OBJECT, DEAL_PIPELINE_STAGE, DEAL_PIPELINE, DEAL_PROPERTY, DEAL, EMAIL, ENGAGEMENT_PROPERTY, FORM, HIERARCHICAL_TEAM, INBOUND_DB_LISTS, INTEGRATION_NAME, INVOICE_PROPERTY, LINE_ITEM_PROPERTY, LINE_ITEM, MULTI_CURRENCY_CURRENCY_CODE, MULTI_CURRENCY_INFORMATION, OBJECT_PROPERTIES, OWNER, PERSONA, QUOTE_PROPERTY, QUOTE, SALESFORCE_CAMPAIGN, SHARED_TASK_QUEUE, SITE_CONTENT, SLACK_CHANNEL, SLACK_USER, TEAM, TICKET_PIPELINE, TICKET_PROPERTY, TICKET_STAGE, TICKET, USER, WEB_INTERACTIVE, WORKFLOW, WORKFLOW_FOLDER
// @ts-expect-error untyped module
} from 'reference-resolvers/constants/ReferenceObjectTypes';
import { ASSIGNABLE_USER, LEGACIED_ASSIGNABLE_USER } from 'automation-ui-action-features/users-and-teams/AssignableUserResolver';
export const ALL_SUPPORTED_REFERENCE_RESOLVER_TYPES = {
  AD_OBJECT_AD_CAMPAIGN,
  AD_OBJECT_AD_GROUP,
  AD_OBJECT_AD,
  ACTIVITY_TYPE,
  ALL_OBJECT_PROPERTIES,
  ASSIGNABLE_USER,
  AUTOMATED_EMAIL,
  AUTOMATION_PLATFORM_WORKFLOWS,
  // Psuedo-resolver type needed specifically to create a custom resolver factory for UnifiedEventsFilter.tsx. See https://hubspot.slack.com/archives/C0224A2LSAE/p1692124020529989
  // 1. We don't want to change existing behavior because it's hard to know what is using this resolver today given how it's written provided at the top level.
  // 2. We need to dynamically query by object type ID
  AUTOMATION_PLATFORM_WORKFLOWS_BY_OBJECT_TYPE_ID: 'AUTOMATION_PLATFORM_WORKFLOWS_BY_OBJECT_TYPE_ID',
  BUSINESS_UNIT,
  CALL_DISPOSITION,
  CHATFLOW_BY_UNIQUE_ID,
  CHATFLOW,
  COMPANY_PROPERTY,
  COMPANY,
  CONTACT_LIST,
  CONTACT_PROPERTY,
  CONTACT_STATIC_LIST,
  CONTACT,
  CONVERSATION_INBOX,
  CTA_GUID,
  CUSTOM_OBJECT_TYPE,
  CUSTOM_OBJECT,
  DEAL_PIPELINE_STAGE,
  DEAL_PIPELINE,
  DEAL_PROPERTY,
  DEAL,
  EMAIL,
  // Psuedo-resolver type needed to specify that we want to exclude email types without a campaign group id. There are a million threads on this- take your pick.
  // https://hubspot.slack.com/archives/C01MWLFE12Q/p1686946604039609
  // https://hubspot.slack.com/archives/C01MWLFE12Q/p1686669479585169?thread_ts=1686669239.130979&cid=C01MWLFE12Q
  // https://hubspot.slack.com/archives/C01MWLFE12Q/p1686669469120069?thread_ts=1686669239.130979&cid=C01MWLFE12Q
  //
  // TLDR; We only support email types that use the `hs_email_campaign_group_id` property as their main identifier
  EMAIL_CAMPAIGN_BY_ID_LEVEL: 'EMAIL_CAMPAIGN_BY_ID_LEVEL',
  ENGAGEMENT_PROPERTY,
  FORM,
  HIERARCHICAL_TEAM,
  INBOUND_DB_LISTS,
  INTEGRATION_NAME,
  INVOICE_PROPERTY,
  LEGACIED_ASSIGNABLE_USER,
  LINE_ITEM_PROPERTY,
  LINE_ITEM,
  MULTI_CURRENCY_CURRENCY_CODE,
  MULTI_CURRENCY_INFORMATION,
  OBJECT_PROPERTIES,
  OWNER,
  PERSONA,
  QUOTE_PROPERTY,
  QUOTE,
  SALESFORCE_CAMPAIGN,
  SHARED_TASK_QUEUE,
  SITE_CONTENT,
  SLACK_CHANNEL,
  SLACK_USER,
  TEAM,
  TICKET_PIPELINE,
  TICKET_PROPERTY,
  TICKET_STAGE,
  TICKET,
  USER,
  WEB_INTERACTIVE,
  WORKFLOW,
  WORKFLOW_FOLDER
};
export const INDEX_PAGE_REFERENCE_RESOLVER_TYPES = {
  AUTOMATION_PLATFORM_WORKFLOWS,
  CONTACT_LIST,
  CUSTOM_OBJECT_TYPE,
  USER,
  WORKFLOW,
  WORKFLOW_FOLDER
};